import { Dispatch } from "../../store.types";
import * as actions from "./facebook-user.actions";

export const saveFacebookInfo = (userInfo: any) => (dispatch: Dispatch) => {
  dispatch(actions.isFacebookUserLoading({ isFacebookUserLoading: true }));
  try {
    if (userInfo.accessToken) {
      sessionStorage.setItem("Meta_Token", userInfo.accessToken);
      sessionStorage.setItem(
        "Facebook_User",
        JSON.stringify({
          name: userInfo?.name,
          email: userInfo?.email,
          picture: {
            data: {
              height: userInfo.picture.data.height,
              is_silhouette: userInfo.picture.data.is_silhouette,
              url: userInfo.picture.data.url,
              width: userInfo.picture.data.width,
            },
          },
          id: userInfo.id,
          userID: userInfo.userID,
        })
      );
    }
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(actions.isFacebookUserLoading({ isFacebookUserLoading: false }));
  }
};

export const getFacebookInfo = () => (dispatch: Dispatch) => {
  dispatch(actions.isFacebookUserLoading({ isFacebookUserLoading: true }));
  try {
    const savedFacebookUser = sessionStorage.getItem("Facebook_User");
    if (savedFacebookUser) {
      dispatch(
        actions.facebookUser({
          facebookUser: JSON.parse(savedFacebookUser),
        })
      );
    }
  } catch (error) {
    console.log(error);
  } finally {
    dispatch(actions.isFacebookUserLoading({ isFacebookUserLoading: false }));
  }
};
